module.exports = __webpack_public_path__ + "img/Product.ae50aced.svg";